import { render, staticRenderFns } from "./o-table.vue?vue&type=template&id=1dbcb510&scoped=true&"
import script from "./o-table.vue?vue&type=script&lang=js&"
export * from "./o-table.vue?vue&type=script&lang=js&"
import style0 from "./o-table.vue?vue&type=style&index=0&id=1dbcb510&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1dbcb510",
  null
  
)

export default component.exports